import moment from "moment";
// import request from "./request";
// import buildURL from "./buildURL";

import axios from "axios";
import {
  getVisitAPIToken,
  getVisitEmail,
  getUserID,
  getVisitAPITokenLocalStorage,
} from "./visitCookies";

export default class KickClient {
  constructor(apiTokenJWT) {
    this.apiTokenJWT = apiTokenJWT;
  }

  // return an authenticated client that can be used for multipart forms.
  static newMultipartAuthenticatedClient() {
    // add form data to request headers
    // https://github.com/axios/axios#form-data
    axios.interceptors.request.use((config) => {
      if (config.data instanceof FormData) {
        Object.assign(config.headers, config.data.getHeaders());
      }
      return config;
    });

    return this.newClient(getVisitAPIToken());
  }

  static newAuthenticatedClient() {
    return this.newClient(getVisitAPITokenLocalStorage());
  }

  static newClient(authToken) {
    const defaultOptions = {
      // mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    var headers = defaultOptions.headers;

    // We use cookie based authentication but adding headers to debug the mysterious 401 errors
    if (authToken) {
      headers = {
        ...headers,
        Authorization: authToken,
      };
    }
    // custom headers
    headers = {
      ...headers,
      "X-KICK-LOCAL-TIME": moment().format(),
      // TODO: try these if mysterious 401 errors persist
      // "X-USERID": getUserID(),
      // "X-EMAIL": getVisitEmail(),
    };

    return axios.create({
      baseURL: "/api/v1/",
      timeout: 60000,
      headers: headers,
    });
  }
}
/**
 * @function REST
 * @description Factory function to create a object that can send
 * requests to a specific resource on the server.
 * @param {string} resource The resource used for config
 */
export const REST = (resource) => {
  // Default options used for every request
  const defaultOptions = {
    // mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  // addAuthHeaders = () => {
  //   let token = sessionStorage.getItem("apiTokenJWT");
  //
  //   if (!_.isEmpty(token)) {
  //     return {
  //       Authorization: "Bearer " + token
  //     };
  //   }
  //
  //   return {};
  // };
  //
  // addLocalTimeHeader = () => {
  //   return {
  //     "X-KICK-LOCAL-TIME": moment().format()
  //   };
  //   // return {};
  // };

  return {
    foo: () => {
      // const authHeaders = this.addAuthHeaders();
      // const localTimeHeader = this.addLocalTimeHeader();

      return axios.create({
        baseURL: "/api/v1/",
        timeout: 1000,
        headers: Object.assign(
          {},
          defaultOptions.headers
          // authHeaders,
          // localTimeHeader
        ),
      });
    },
    //
    // /**
    //  * @function post
    //  * @description Make a POST request.
    //  * @param {string} path
    //  * @param {object} body
    //  * @param {object} options
    //  * @returns {promise}
    //  */
    // post: (path, body, options = {}) => {
    //   // console.log("*** POST: ", path);
    //   // console.log(store.getState());
    //   // console.log(JSON.stringify(body));
    //
    //   const headers = Object.assign(
    //     {},
    //     defaultOptions.headers
    //     // this.addAuthHeaders(),
    //     // this.addLocalTimeHeader()
    //   );
    //
    //   // console.log(path);
    //   // console.log("POST BODY: ", body);
    //   // console.log(authHeaders);
    //   // return request(
    //   //   buildURL(path),
    //   //   Object.assign(
    //   //     options,
    //   //     defaultOptions,
    //   //     { headers: headers },
    //   //     {
    //   //       method: "POST",
    //   //       body: JSON.stringify(body)
    //   //     }
    //   //   )
    //   // );
    //
    //   return foo.post(path, body, options);
    // },
    //
    // /**
    //  * @function post
    //  * @description Make a GET request.
    //  * @param {string} path
    //  * @param {object} options
    //  * @returns {promise}
    //  */
    // get: (path, options = {}) => {
    //   const headers = Object.assign(
    //     {},
    //     defaultOptions.headers
    //     // addAuthHeaders(),
    //     // addLocalTimeHeader()
    //   );
    //
    //   return request(
    //     buildURL(path),
    //     Object.assign(
    //       options,
    //       defaultOptions,
    //       { headers: headers },
    //       { method: "GET" }
    //     )
    //   );
    // },
    //
    // /**
    //  * @function edit
    //  * @description Make a PUT request.
    //  * @param {string} path
    //  * @param {object} body
    //  * @param {object} options
    //  * @returns {promise}
    //  */
    // put: (path, body, options = {}) => {
    //   const headers = Object.assign(
    //     {},
    //     defaultOptions.headers
    //     // addAuthHeaders(),
    //     // addLocalTimeHeader()
    //   );
    //
    //   return request(
    //     buildURL(path),
    //     Object.assign(
    //       options,
    //       defaultOptions,
    //       { headers: headers },
    //       {
    //         method: "PUT",
    //         body: JSON.stringify(body)
    //       }
    //     )
    //   );
    // },
    //
    // /**
    //  * @function delete
    //  * @description Make a DELETE request.
    //  * @param {string} path
    //  * @param {object} options
    //  * @returns {promise}
    //  */
    // delete: (path, options = {}) => {
    //   const headers = Object.assign(
    //     {},
    //     defaultOptions.headers
    //     // addAuthHeaders(),
    //     // addLocalTimeHeader()
    //   );
    //
    //   return request(
    //     buildURL(path),
    //     Object.assign(
    //       options,
    //       defaultOptions,
    //       { headers: headers },
    //       {
    //         method: "DELETE"
    //       }
    //     )
    //   );
    // }
  };
};

// export const Auth = () => {
//   return {
//     updateSignup: body => {
//       return REST.post("/signup-details", body);
//     }
//   };
// };
